import {
  IndividualAccountTypeEnum,
  ComplianceIndividualProfileInput,
} from "../../graphql/supergraphTypes";
import { resolvedAccountType } from "../../utils/account_types";
import {
  getProfileDate,
  prepareAddressFromForm,
} from "../common/ProfileManagement/profile_utils";
import { IndividualProfile } from "../IndividualForm/types";
import { DeclarationProfileType } from "../profile/ProfileDeclaration/types";

export const prepareIndividualPayload = (
  caseId: number,
  values: IndividualProfile,
  profile?: DeclarationProfileType | null,
  taxId?: string | null,
): ComplianceIndividualProfileInput => {
  return {
    caseId: caseId,
    firstName: values.firstName || "",
    middleName: values.middleName,
    lastName: values.lastName || "",
    accountType:
      (values.accountType as IndividualAccountTypeEnum) || resolvedAccountType(profile),
    dateOfBirth: getProfileDate(values.dateOfBirth),
    ...(taxId !== undefined && { taxId }),
    taxIdType: profile?.taxIdType,
    relationshipType: profile?.parentRelationships?.map(
      (relationship) => relationship.relationshipType,
    ),
    addresses: [prepareAddressFromForm(values)],
  };
};
